import { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Servicios from "../components/Servicios";
import Contacto from "../components/Contacto";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

export default function HomePage() {
    // Smooth-scroll to anchor on initial load (e.g. /#servicios)
    useEffect(() => {
        if (window.location.hash) {
            const id = window.location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
            }
        }
    }, []);

    return (
        <div className="bg-[#0A0A0A] text-white min-h-screen" data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <Servicios />
                <Contacto />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}
